import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { ButtonBasic } from '@/component-style/Button';
import { Table, TableBody } from '@/component-style/Table';
import PageSelector from '@/components/UI/PageSelector';
import Header from './Header';
import Item from './Item';

const DivWrapper = styled.div`
  width: 100%;
  border-top: 2px solid #de2027;
  background-color: #ffffff;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
`;

const TitleWrapper = styled.div`
  margin-top: 35px;
  margin-bottom: 20px;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const H3Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: normal;
  color: #57585a;
`;

const Button = styled(ButtonBasic)`
  width: 120px;
  height: 40px;
`;

const TableExpenseQuotations = props => {
  const history = useHistory();
  const expenseRoutes = useSelector(state => state.login.expenseRoutes);

  const disableDetailPage = expenseRoutes.indexOf('ExpenseQuotationDetail') === -1;
  const userDeletable = expenseRoutes.indexOf('ExpenseQuotationDetail-Delete') !== -1;
  const attachUploadable = expenseRoutes.indexOf('ExpenseQuotationDetail-Attachments') !== -1;
  const licenseUploadable = expenseRoutes.indexOf('ExpenseQuotationDetail-License') !== -1;

  const { quotations } = props;

  return (
    <DivWrapper>
      <TitleWrapper>
        <H3Title>採購列表</H3Title>
        <Button
          disabled = { props.disableConvert }
          onClick = { props.quotationConvertHandler }
        >結轉支憑</Button>
      </TitleWrapper>
      <Table>
        <Header
          selectAll = { props.selectAll }
          selectAllHandler = { props.selectAllHandler }
        />
        <TableBody>
          {
            quotations.map((quotation, index) =>
              <Item
                key = { quotation.quotationID }
                quotation = { quotation }
                userDeletable = { userDeletable }
                attachUploadable = { attachUploadable }
                licenseUploadable = { licenseUploadable }
                disableDetailPage = { disableDetailPage }
                checkHandler = { value => {
                  props.checkHandler(index, value);
                }}
                goDetailHandler = {() => {
                  window.open(`/Expense/ExpenseFormDetail/${quotation.expenseID}`, "_blank")
                  // history.push(`/Expense/ExpenseQuotationDetail/${ quotation.quotationID }`);
                }}
                attachmentHandler = { () => {
                  props.openFilesPopupHandler('quotationFiles', quotation.quotationID)
                }}
                voucherHandler = { () => {
                  props.openFilesPopupHandler('quotationVoucher', quotation.quotationID)
                }}
                deleteHandler = { () => {
                  props.deleteHandler(quotation.quotationID)
                }}
              />
            )
          }
        </TableBody>
      </Table>
      <PageSelector
        disabled = { true }
      />
    </DivWrapper>
  );
};

export default TableExpenseQuotations;
